import { render, staticRenderFns } from "./OfferGoals.vue?vue&type=template&id=36644125&"
import script from "./OfferGoals.vue?vue&type=script&lang=ts&"
export * from "./OfferGoals.vue?vue&type=script&lang=ts&"
import style0 from "./OfferGoals.vue?vue&type=style&index=0&id=36644125&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports